import { FC } from "react";
import { RsvpFormName } from "./RsvpFormName/RsvpFormName";
import { RsvpFormWillAttend } from "./RsvpFormWillAttend/RsvpFormWillAttend";
import { RsvpFormMessage } from "./RsvpFormMessage/RsvpFormMessage";
import { FormProvider, useForm } from "react-hook-form";
import { RsvpFormSubmit } from "./RsvpFormSubmit/RsvpFormSubmit";
import { RsvpFormStatus } from "./RsvpFormStatus/RsvpFormStatus";
import { useAsyncFn } from "react-use";
import { client } from "../Rsvp.client";

interface RsvpFormData {
  guest: string;
  message: string;
  willAttend: "true" | "false";
}

export const RsvpForm: FC = () => {
  const form = useForm<RsvpFormData>();

  const [{ value }, save] = useAsyncFn(
    async ({ guest, message, willAttend }: RsvpFormData) => {
      const { items } = await client.entry.getMany({
        query: {
          order: "fields.title",
          content_type: "guest",
        },
      });
      const response = await client.entry.create(
        {
          contentTypeId: "response",
        },
        {
          fields: {
            title: {
              "en-US": items.find(({ sys: { id } }) => id === guest)?.fields
                .title["en-US"],
            },
            guest: {
              "en-US": {
                sys: {
                  type: "Link",
                  linkType: "Entry",
                  id: guest,
                },
              },
            },
            message: {
              "en-US": message,
            },
            willAttend: {
              "en-US": willAttend === "true",
            },
          },
        }
      );
      const published = await client.entry.publish(
        {
          entryId: response.sys.id,
        },
        response
      );
      form.reset();
      return published;
    },
    [form]
  );

  const handleOnSubmit = form.handleSubmit(async (data) => {
    await save(data);
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={handleOnSubmit}>
        <RsvpFormName key={`${value?.sys?.id}name`} />
        <RsvpFormWillAttend key={`${value?.sys?.id}attend`} />
        <RsvpFormMessage key={`${value?.sys?.id}message`} />
        {!!value && <RsvpFormStatus />}
        <RsvpFormSubmit />
      </form>
    </FormProvider>
  );
};
